import { render } from "./TheMucTruongChuan.vue?vue&type=template&id=9817c244"
import script from "./TheMucTruongChuan.vue?vue&type=script&lang=js"
export * from "./TheMucTruongChuan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__